import React from 'react';
import PropTypes from 'prop-types';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {
    SHORT_CAROUSEL_ASPECT_RATIO,
    TALL_CAROUSEL_ASPECT_RATIO,
    CAROUSEL_ASPECT_RATIO_16X9,
    CAROUSEL_ASPECT_RATIO_3X2,
    CAROUSEL_ASPECT_RATIO_1X1,
} from '../../common/constants';
import Title from '../Title';
import CardContent from '../CardContent';
import CardImage from '../CardImage';

import './BaseCard.less';

const BaseCard = ({
    alt,
    aspectRatio,
    children,
    imageOverlay,
    imageUri,
    loadImage,
    svgIcon,
    title,
    ...rest
}) => {
    const imageProps = {
        alt,
        aspectRatio,
        imageOverlay,
        imageUri,
        loadImage,
        svgIcon,
    };
    return (
        <AspectRatioCard aspectRatio={aspectRatio} {...rest}>
            <CardImage data-slot="figure" {...imageProps} />
            {title && <Title data-slot="caption">{title}</Title>}
            {children && (
                <CardContent data-slot="content">{children}</CardContent>
            )}
        </AspectRatioCard>
    );
};

BaseCard.propTypes = {
    /** The image alt */
    alt: PropTypes.string,
    /** Value to determine whether to use a short or a tall card */
    aspectRatio: PropTypes.oneOf([
        TALL_CAROUSEL_ASPECT_RATIO,
        SHORT_CAROUSEL_ASPECT_RATIO,
        CAROUSEL_ASPECT_RATIO_16X9,
        CAROUSEL_ASPECT_RATIO_3X2,
        CAROUSEL_ASPECT_RATIO_1X1,
    ]),
    /** An image overlay component instance */
    imageOverlay: PropTypes.node,
    /** The image source url */
    imageUri: PropTypes.string,
    /** Whether to show the image (used for lazy loading) */
    loadImage: PropTypes.bool,
    /** SVG icon to display for CardImage Placeholder when no imageUri is present */
    svgIcon: PropTypes.string,
    /** The card title */
    title: PropTypes.string,
};

BaseCard.defaultProps = {
    aspectRatio: SHORT_CAROUSEL_ASPECT_RATIO,
};

export default BaseCard;
